import { writable } from "svelte/store";
import { getUserManager } from '../auth/auth';

export const PERMISSION_VIEW_PROJECTS = writable<boolean>(false);
export const PERMISSION_MODIFY_PROJECTS = writable<boolean>(false);
export const PERMISSION_VIEW_INSIGHT = writable<boolean>(false);
export const PERMISSION_USE_INSIGHT = writable<boolean>(false);
export const PERMISSION_CONFIG_INSIGHT = writable<boolean>(false);
export const PERMISSION_VIEW_ACCESS = writable<boolean>(false);
export const PERMISSION_VIEW_RATES = writable<boolean>(false);
export const PERMISSION_VIEW_SIGNALLING = writable<boolean>(false);
export const PERMISSION_VIEW_DASHBOARD = writable<boolean>(false);

//TODO Share wth backend
export const storeMap = {
    'view-projects': PERMISSION_VIEW_PROJECTS,
    'modify-projects': PERMISSION_MODIFY_PROJECTS,
    'view-insight': PERMISSION_VIEW_INSIGHT,
    'use-insight': PERMISSION_USE_INSIGHT,
    'config-insight': PERMISSION_CONFIG_INSIGHT,
    'view-access': PERMISSION_VIEW_ACCESS,
    'view-rates': PERMISSION_VIEW_RATES,
    'view-signalling': PERMISSION_VIEW_SIGNALLING,
    'view-dashboard': PERMISSION_VIEW_DASHBOARD
}

export async function fetchPermissions() {
    const userManager = getUserManager();
    const user = await userManager.getUser();
    const userRole = user?.profile?.realm_access?.roles[0];
    const userPermissions = getPermissionsByRole(userRole);
    for (const permission of userPermissions) {
        storeMap[permission].set(true);
    }
}

const getPermissionsByRole = (role: string) => {
    switch (role) {
        case 'admin':
        case 'user':
            return [
                "view-projects",
                "view-dashboard",
                "view-insight",
                "use-insight",
                "config-insight",
                "modify-projects"
            ];
        case 'viewer':
            return [
                "view-projects",
                "view-dashboard",
                "view-insight"
            ];
        case 'guest':
            return [
                "view-projects",
                "view-dashboard"
            ];
        default:
            return [];
    }
};
